var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { childrenExist, customPropTypes, UIComponent, commonPropTypes, } from '../../lib';
import HeaderDescription from './HeaderDescription';
/**
 * A header provides a short summary of content.
 * @accessibility
 * Headings communicate the organization of the content on the page. Web browsers, plug-ins, and assistive technologies can use them to provide in-page navigation.
 * Nest headings by their rank (or level). The most important heading has the rank 1 (<h1>), the least important heading rank 6 (<h6>). Headings with an equal or higher rank start a new section, headings with a lower rank start new subsections that are part of the higher ranked section.
 *
 * Other considerations:
 *  - when the description property is used in header, readers will narrate both header content and description within the element.
 *    In addition to that, both will be displayed in the list of headings.
 */
var Header = /** @class */ (function (_super) {
    __extends(Header, _super);
    function Header() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Header.prototype.renderComponent = function (_a) {
        var ElementType = _a.ElementType, classes = _a.classes, v = _a.variables, rest = _a.rest;
        var _b = this.props, children = _b.children, content = _b.content, description = _b.description;
        if (childrenExist(children)) {
            return (React.createElement(ElementType, __assign({}, rest, { className: classes.root }), children));
        }
        return (React.createElement(ElementType, __assign({}, rest, { className: classes.root }),
            content,
            HeaderDescription.create(description, {
                defaultProps: {
                    variables: __assign({}, (v.descriptionColor && { color: v.descriptionColor })),
                },
            })));
    };
    Header.className = 'ui-header';
    Header.displayName = 'Header';
    Header.propTypes = __assign({}, commonPropTypes.createCommon({ color: true }), { description: customPropTypes.itemShorthand, textAlign: PropTypes.oneOf(['left', 'center', 'right', 'justified']) });
    Header.defaultProps = {
        as: 'h1',
    };
    Header.Description = HeaderDescription;
    return Header;
}(UIComponent));
export default Header;
